import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 503,
  name: 'Service Unavailable',
  description:
    'The server is temporarily unable to handle the request. This is usually due to the server being overloaded with traffic, undergoing maintenance, or having its resources exhausted. A Retry-After header may indicate when to try again.',
  causes: [
    'The server is overloaded — too many concurrent requests are exhausting CPU, memory, or connection pool capacity.',
    'Planned maintenance or deployment in progress. The server returns 503 intentionally while updating.',
    'A dependency (database, cache, external API) is down, and the server cannot serve requests without it.',
  ],
  fixes: [
    'If under heavy load, scale up (more resources) or scale out (more instances). Enable auto-scaling if your infrastructure supports it.',
    'If in maintenance mode, wait for it to complete. If you control the server, check that the maintenance window has not exceeded its expected duration.',
    'Check downstream dependencies: database connections, Redis, external APIs. A 503 often means a backing service is unreachable rather than the web server itself.',
  ],
  monitoringTip:
    'Uptrack distinguishes between brief 503 blips and sustained outages by confirming consecutive failures before alerting. This means you get notified about real downtime, not transient load spikes during a deploy.',
}

export const Route = createFileRoute('/_site/http/503')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
